import PropTypes from 'prop-types'
import Alert from 'react-bootstrap/Alert'

import Report from '~/components/shared/Report'
import UserMedia from '~/components/shared/UserMedia'
import withLocale from '~/hocs/locale'
import { UserPropType } from '~/utils/prop-types'

const CommentList = ({
  messages, noCommentsAlert, className, onAuthRequire
}) => {
  if (messages.length === 0) return <Alert variant="info">{noCommentsAlert}</Alert>

  return (
    <div className={className}>
      {messages.map((message) => (
        <div className="border-top px-2 py-3" key={message.id}>
          <div className="d-flex justify-content-between mb-2">
            <UserMedia value={message} />
            <Report messageId={message.id} onAuthRequire={onAuthRequire} />
          </div>
          {message.body}
        </div>
      ))}
    </div>
  )
}

CommentList.propTypes = {
  noCommentsAlert: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    body: PropTypes.string,
    createdAt: PropTypes.string,
    showAuthor: PropTypes.bool,
    author: UserPropType,
    votesByReasonMessageId: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.shape({
        positive: PropTypes.bool
      }))
    })
  })).isRequired,
  reportMessages: PropTypes.shape({
    success: PropTypes.string.isRequired,
    errors: PropTypes.shape({
      reportAlreadyExists: PropTypes.string.isRequired,
      default: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onAuthRequire: PropTypes.func.isRequired,
  className: PropTypes.string
}

CommentList.defaultProps = {
  className: '',
}

export default withLocale('common', 'commentList')(CommentList)
